<template>
  <div>
    <AppButton
      v-if="!href"
      lang="sv"
      color="secondary"
      size="sm"
      class="min-w-72"
      :full-width="true"
      :disabled="disabled"
      :aria-disabled="disabled"
      :aria-label="ariaLabel"
      @click="$emit('onClick')"
    >
      <slot></slot>
    </AppButton>

    <AppButton
      v-if="href"
      lang="sv"
      color="secondary"
      size="sm"
      class="min-w-44"
      :full-width="true"
      :href="href"
      :aria-label="ariaLabel"
    >
      <slot></slot>
    </AppButton>
  </div>
</template>

<script lang="ts" setup>
export type ButtonType = 'button' | 'submit' | 'reset';

interface Props {
  href?: string;
  disabled?: boolean;
  ariaLabel?: string;
  buttonType?: ButtonType;
}

withDefaults(defineProps<Props>(), {
  href: undefined,
  disabled: false,
  ariaLabel: undefined,
  buttonType: 'submit',
});

defineEmits(['onClick']);
</script>

<style scoped lang="scss">
a {
}
</style>
